
import { Button } from '@/components/ui/button';

interface MediaLibraryButtonProps {
  openMediaLibrary: () => void;
}

export default function MediaLibraryButton({ openMediaLibrary }: MediaLibraryButtonProps) {
  return (
    <Button
      size="sm"
      variant="outline"
      className="h-8 border-white/10 bg-black/40"
      onClick={e => {
        e.preventDefault();
        openMediaLibrary();
      }}
      type="button"
    >
      Media Library
    </Button>
  );
}
